import { OutGoingEvents } from './types';

export const EKA_EVENT = 'eka-event';
export const DOC_ASSIST_EVENT = 'DOC_ASSIST_EVENT';

export const dispatch = (event: OutGoingEvents): void => {
    dispatchEvent(new CustomEvent(EKA_EVENT, { detail: event }));
};

export const dispatchDocAssist = (event: OutGoingEvents): void => {
    dispatchEvent(new CustomEvent(DOC_ASSIST_EVENT, { detail: event }));
};
